import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

function Content({ cart }) {
  const newLocal = useParams();
  const { pageKey } = newLocal ?? "404";
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content/${pageKey}`)
      .then(res => res.json())
      .then(data => {
        setTitle(data.title ?? "");
        setContent(`<h1>${data.title}</h1>` + data.content ?? "");
      })
      .catch(err => console.error(`Error loading ${pageKey} content`, err));
  }, [pageKey]);

  return (
    <div className="pane pane-center dark_pane"
            dangerouslySetInnerHTML={{ __html: content }}>
    </div>
  );
}

export default Content;